import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/products/about-nagase/play_button.png")